import React from "react";
import DotsPattern from "../../../components/ui/icons/DotsPattern";
import BannerAvatar from "../../../components/ui/BannerAvatar";
import { useProfile } from "../../auth/hooks/useProfile";

const CoachWelcomeBanner: React.FC = () => {
  const { user } = useProfile();

  return (
    <div
      className="relative rounded-xl overflow-hidden mb-6 flex flex-col sm:flex-row items-center sm:items-center min-h-[200px]"
      style={{
        background:
          "linear-gradient(-23deg, rgba(0, 103, 255, .175) 0%, #ffffff 100%)",
        padding: "32px 24px",
        gap: 24,
        boxShadow: "0 2px 14px #0000001a",
      }}
    >
      <DotsPattern />

      {/* Avatar */}
      <div className="relative z-[1] flex-shrink-0">
        <BannerAvatar src={user?.image ?? undefined} />
      </div>

      {/* Text content */}
      <div className="relative z-[1] flex flex-col items-center text-center sm:items-start sm:text-left">
        {/*  Coach badge */}
        <div
          className="flex items-center gap-1.5 mb-3 px-3 py-1 rounded-full"
          style={{ background: "rgba(0,103,255,0.1)" }}
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#0067ff"
            strokeWidth="2.5"
          >
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
          </svg>
          <span className="text-[11px] font-bold uppercase tracking-wider font-primary text-[#0067ff]">
            Coach
          </span>
        </div>

        <h1
          className="font-medium mb-2 font-primary text-blue"
          style={{
            fontSize: "clamp(20px, 3vw, 26px)",
            lineHeight: 1.2,
          }}
        >
          Welcome, {user?.first_name}!
        </h1>

        <div
          style={{
            width: 40,
            height: 3,
            background: "#3b519c",
            borderRadius: 2,
            marginBottom: 14,
          }}
        />

        <p
          className="font-medium font-primary leading-normal max-w-[400px] mb-0"
          style={{ color: "var(--blue)" }}
        >
          Here are the teams you are coaching. Track progress, view results and
          support your team's growth.
        </p>
      </div>
    </div>
  );
};

export default CoachWelcomeBanner;
